import { useInfiniteQuery } from '@tanstack/react-query'
import { useCallback, useMemo } from 'react'

import { QUERY_KEYS } from '~constants'
import { getOffersRequest } from '~services'
import { OffersListInput } from '~types/offer'

const { OFFERS_LIST } = QUERY_KEYS

const offersQueryKey = [OFFERS_LIST] as [string]
const limitOnPage = 10

// FIXME: Fix options type for useInfiniteQuery
//type options =  Omit<
//     UseInfiniteQueryOptions<
//       unknown,
//       (lastPage: OffersListResponse) => number,
//       OffersListResponse,
//       unknown,
//       ([string] | OffersListInput | undefined)[]
//     >,
//     'queryKey' | 'queryFn'
//   >

export function useGetOffers(params?: OffersListInput, options?: { enabled: boolean }) {
  const getOffers = useCallback(
    ({ pageParam }: { pageParam?: number }) => {
      return getOffersRequest({
        ...params,
        limit: limitOnPage,
        offset: pageParam && pageParam * limitOnPage,
      })
    },
    [params]
  )

  const {
    fetchNextPage,
    data,
    hasNextPage,
    isFetchingNextPage,
    isLoading: isLoadingOffers,
    isRefetching: isRefetchingOffers,
    refetch: refetchOffers,
  } = useInfiniteQuery([offersQueryKey, params], getOffers, {
    getNextPageParam: (lastPage, allPages) => {
      const lastPageOffersLength = lastPage.offers.length

      return lastPageOffersLength === limitOnPage ? allPages.length : undefined
    },
    staleTime: 5000,
    ...options,
  })

  const offersList = useMemo(() => data?.pages.map((el) => el.offers).flat() || [], [data])

  return {
    offers: offersList,
    isLoadingOffers,
    isRefetchingOffers,
    isFetchingNextPage,
    refetchOffers,
    hasNextPage,
    fetchNextPage,
  }
}

useGetOffers.queryKey = () => offersQueryKey
